import flatpickr from "flatpickr";

import { Spanish } from "flatpickr/dist/l10n/es.js";
import { English } from "flatpickr/dist/l10n/default.js";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Czech } from "flatpickr/dist/l10n/cs.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import { Polish } from "flatpickr/dist/l10n/pl.js";

bcl.s.flatpickr = {
  props: {
    cssSelector: "flatpickr",
    config: {
      disableMobile: true,
    },
    dependencies: {},
    instances: {},
    setLocale: false,
  },

  preInit: function () {
    bcl.u.docReady(bcl.s.flatpickr.init);
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-flatpickr.css");

    const baseFind = baseDom ? baseDom : document,
      elements = baseFind.querySelectorAll("." + bcl.s.flatpickr.props.cssSelector),
      locale = bcl.u.getPageLanguage();

    if (!bcl.s.flatpickr.props.setLocale) {
      bcl.s.flatpickr.addLocale(locale);
      bcl.s.flatpickr.props.setLocale = true;
      bcl.s.flatpickr.props.config.altInput = true;
      bcl.s.flatpickr.props.config.altFormat = bcl.s.flatpickr.localeFormatDate(locale);
    }

    for (let i = 0; i < elements.length; i++) {
      bcl.s.flatpickr.process(elements[i]);
    }
  },

  process: function ($element) {
    if ($element.classList.contains("flatpickr-static")) {
      bcl.s.flatpickr.props.config.static = true;
    }

    const config = bcl.u.deepExtend({}, bcl.s.flatpickr.props.config);

    config.onChange = function () {
      bcl.s.flatpickr.onChange($element, $element.id);
    };

    if ($element.dataset.format) {
      config.dateFormat = $element.dataset.format;
    }

    if ($element.dataset.altformat) {
      config.altInput = true;
      config.altFormat = $element.dataset.altformat;
    }

    if ($element.dataset.mindatenow) {
      config.minDate = "today";
    }

    if ($element.dataset.dependency) {
      bcl.s.flatpickr.inputDependency($element);
    }

    if ($element.dataset.clickOpens) {
      config.clickOpens = $element.dataset.clickOpens;
    }

    if ($element.value) {
      config.defaultDate = $element.value;
    }

    $element.setAttribute("readonly", "readonly");

    if (bcl.u.containsClass($element, "calendar-birth-JS")) {
      config.maxDate = new Date().setFullYear(new Date().getFullYear() - 18);
      bcl.s.flatpickr.props.instances[$element.id] = flatpickr($element, config);
      config.maxDate = undefined;
    } else {
      bcl.s.flatpickr.props.instances[$element.id] = flatpickr($element, config);
    }
  },

  inputDependency: function ($element) {
    const name = $element.dataset.dependency;

    if (bcl.s.flatpickr.props.dependencies[name]) {
      bcl.s.flatpickr.props.dependencies[name].push($element.id);
    } else {
      bcl.s.flatpickr.props.dependencies[name] = [$element.id];
    }
  },

  onChange: function ($element, key) {
    const $input = bcl.s.flatpickr.props.instances[key]._input,
      $form = $input.closest("form");

    $input.setAttribute("value", $input.value);

    bcl.s.form.validateInputStatus($input, $form);

    if (!bcl.s.flatpickr.props.dependencies[key]) {
      return;
    }

    const data = bcl.s.flatpickr.props.dependencies[key];

    for (let i = 0; i < data.length; i++) {
      bcl.s.flatpickr.processDependency(data[i], key);
    }
  },

  processDependency: function (key, keyDep) {
    const instance = bcl.s.flatpickr.props.instances[key],
      $input = instance.input;

    if ($input.dataset.attrdep) {
      instance.set($input.dataset.attrdep, bcl.s.flatpickr.props.instances[keyDep].input.value);
    }
  },

  addLocale: function (locale) {
    const localeMap = {
      // Spanish
      "es-es": Spanish,
      "es-ww": Spanish,
      "es-us": Spanish,
      "es-mx": Spanish,
      "es-ar": Spanish,
      "es-do": Spanish,
      "es-co": Spanish,
      "es-cl": Spanish,
      "es-cr": Spanish,
      "es-ni": Spanish,

      // English
      "en-es": English,
      "en-gb": English,
      "en-ww": English,
      "en-au": English,
      "en-cn": English,
      "en-ie": English,
      "en-ca": English,
      "en-ae": English,
      "en-in": English,
      "en-us": English,

      // Russian
      "ru-ru": Russian,

      // Italian
      "it-it": Italian,

      // Czech
      "cs-cz": Czech,

      // French
      "fr-fr": French,
      "fr-ma": French,
      "fr-ww": French,

      // Arabic
      "ar-ar": Arabic,
      "ar-ww": Arabic,
      "ar-ae": Arabic,

      // Portuguese
      "pt-br": Portuguese,
      "pt-pt": Portuguese,

      // German
      "de-tr": German,
      "de-de": German,
      "de-ch": German,

      // Turkish
      "tr-tr": Turkish,

      // Polish
      "pl-pl": Polish,
    };

    const selectedLocale = localeMap[locale] || English; // Default to English if locale is not found
    flatpickr.localize(selectedLocale);
  },

  localeFormatDate: function (locale) {
    const formats = {
      // Spanish
      "es-es": "d/m/Y",
      "es-ww": "d/m/Y",
      "es-us": "d/m/Y",
      "es-mx": "d/m/Y",
      "es-ar": "d/m/Y",
      "es-do": "d/m/Y",
      "es-co": "d/m/Y",
      "es-cl": "d/m/Y",
      "es-cr": "d/m/Y",
      "es-ni": "d/m/Y",

      // English (American format)
      "en-es": "m/d/Y",
      "en-gb": "m/d/Y",
      "en-ww": "m/d/Y",
      "en-au": "m/d/Y",
      "en-cn": "m/d/Y",
      "en-ie": "m/d/Y",
      "en-ca": "m/d/Y",
      "en-ae": "m/d/Y",
      "en-in": "m/d/Y",
      "en-us": "m/d/Y",

      // Russian
      "ru-ru": "d.m.Y",

      // Italian
      "it-it": "d/m/Y",

      // Czech
      "cs-cz": "d.m.Y",

      // French
      "fr-fr": "d/m/Y",
      "fr-ma": "d/m/Y",
      "fr-ww": "d/m/Y",

      // Arabic
      "ar-ar": "d/m/Y",
      "ar-ww": "d/m/Y",
      "ar-ae": "d/m/Y",

      // Portuguese
      "pt-br": "d/m/Y",
      "pt-pt": "d/m/Y",

      // German
      "de-tr": "d.m.Y",
      "de-de": "d.m.Y",
      "de-ch": "d.m.Y",

      // Turkish
      "tr-tr": "d.m.Y",

      // Polish
      "pl-pl": "d.m.Y",
    };

    return formats[locale] || "d/m/Y"; // Default to day/month/year format
  },
};

bcl.preInit.push(bcl.s.flatpickr.preInit);
